// Auto-generated: imports for all post layout scripts
// This file is maintained by scripts/build-assets.js
// Do not edit manually - changes will be overwritten

import '../../flex/post_layouts/post/post.js';
